// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.container{\n  margin-left:auto;\n  margin-right:auto;\n  padding-left:1rem;\n  padding-right:1rem\n}\n@media (min-width: 1024px){\n.container{\n    padding-left:0px;\n    padding-right:0px\n}\n}\n.vm--overlay{\n  background:rgba(0,0,0,.9)!important\n}\n.vm--modal{\n  background-color:transparent !important\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
